import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import CampaignPurposesController from '../controllers/CampaignPurposesController';
import commonHandler from '../errorHandlers/common-handler';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';

class CampaignsPurposesCRUDActions extends CrudActionContainer {
  constructor() {
    super('CAMPAIGNS_PURPOSES');
  }

  retrieveAll() {
    return async (
      dispatch: Dispatch<StoreState>,
      getState: () => StoreState,
    ) => {
      const { campaignPurposes } = getState();

      // No need to fetch if already set as is a constant
      if (campaignPurposes.purposes && campaignPurposes.purposes.length) {
        return;
      }

      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await CampaignPurposesController.getAll();
        dispatch(this.retrievedAll(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }
}

const campaignPurposesCRUDActions = new CampaignsPurposesCRUDActions();

export default campaignPurposesCRUDActions;

export const useCampaignPurposesCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return useMemo(
    () => ({
      retrieveAll: (
        ...args: Parameters<typeof campaignPurposesCRUDActions.retrieveAll>
      ) => dispatch(campaignPurposesCRUDActions.retrieveAll(...args)),
    }),
    [dispatch],
  );
};
